import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=01866518&"
import script from "./Quota.vue?vue&type=script&lang=ts&"
export * from "./Quota.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports